export default __webpack_public_path__ + "static/media/icon_cart.4bc1bfa8.svg";